import React, { Component } from "react";
import * as firebase from "firebase/app";
import "firebase/analytics";
import { connect } from "react-redux";
import { renderRoutes } from "react-router-config";
import Header from "./components/common/header";
import Footer from "./components/common/footer";
import Menu from "./components/common/menu";
import { LoaderComponent } from "./components/loader";
import Modal from "./components/shared/Modal";
import { IsEmpty, signUpAnalytics, fetchNotification } from "./util/commonFunctions";
import { setToken, setUser, logout, setSignupFlow, setSignupModalStatus } from "./actions";
import { axiosContentDetail, axiosUserManagement } from "./axios";
import { analytics, setUserProperties, getFirebaseCofig } from "./analytics";
import SigninPopup from "./components/popUp/signinPopup";
import { isMobile } from 'react-device-detect';
import QuestionPopup from "./components/onboardingQuestion/QuestionPopup";
import { getContentWithLanguage } from "./util/language";
import { handleActionError } from "./util/error";

// Your web app's Firebase configuration
const firebaseConfig = getFirebaseCofig();
const setTimeoutMessage = 6000;
const MAX_NOTIFICATIONS_ALLOWED = 12;


class App extends Component {
  constructor(props) {
    super(props);

    this.mainWrapperClass = "mainContainer";
    this.setParentWrapperClass(this.props, false);
    this.state = {
      openPopup: false,
      activePopup: null,
      nodeTier: null,
      nodeSeries: null,
      linkedInErrorMessage: null,
      showLoginModal: false,
      userAuthenticationForm: 'signin',
      notification: [],
      showNotification: false,
      showSchedule: false,
      showOnboardingQues: false,
      onboardingQues: []
    };

    if (!firebase.apps.length) firebase.initializeApp(firebaseConfig);
  }

  componentDidCatch(error, errorInfo) {
    console.error('An uncaught error occurred:', error);
    console.log('Further error info:', errorInfo);
  }

  setParentWrapperClass = (props, isLoggedin = false) => {
    if (isLoggedin) {
      if (props.location.pathname.indexOf("search") > 0) {
        this.mainWrapperClass = "tokenValid searchView";
      } else if (props.location.pathname.indexOf("topic/") > 0) {
        this.mainWrapperClass = "tokenValid topicWrapper";
      } else if (props.location.pathname.indexOf("events/") > 0) {
        this.mainWrapperClass = "";
      } else {
        this.mainWrapperClass = "tokenValid";
      }
    } else {
      if (props.location.pathname.indexOf("search") > 0) {
        this.mainWrapperClass = "mainContainer searchView";
      } else if (props.location.pathname.indexOf("topic/") > 0) {
        this.mainWrapperClass = "mainContainer topicWrapper";
      } else if (props.location.pathname.indexOf("events/") > 0) {
        this.mainWrapperClass = "";
      } else {
        this.mainWrapperClass = "mainContainer";
      }
    }
  }

  showScheduleToggler = () => {
    this.setState(prevState => {
      return { showSchedule: !prevState.showSchedule };
    });
  }

  fetchNotificationHandler = (response, error) => {
    if (response && !IsEmpty(response)) {
      this.setState({
        notification: response
      });
    }
  }

  componentDidCatch(error) {
    console.error("Component did catch:", error);
	}

  componentDidUpdate = prevProps => {
    if (this.state.notification && this.state.notification.length == 0 && !IsEmpty(localStorage.getItem("token"))) {
      fetchNotification(this.fetchNotificationHandler, localStorage.getItem("token"));
    }
    if (this.props.location.pathname != prevProps.location.pathname) {
      window.scrollTo(0, 0);
      if (
        document.getElementsByClassName("liClass") &&
        document.getElementsByClassName("liClass")[0]
      ) {
        document
          .getElementsByClassName("liClass")[0]
          .classList.remove("active");
      }
      this.resetPopupProps();

      if (this.props.location.search != "") {
        let searchParams = new URLSearchParams(
          this.props.location.search.split("?")[1]
        );
        this.switchPopup(searchParams);
      }
      if (!IsEmpty(this.props.token)) {
        fetchNotification(this.fetchNotificationHandler, localStorage.getItem("token"));
        this.fetchOnboardingQuestion(this.props.currentLanguage);
      }
      if (localStorage.getItem("token") && localStorage.getItem("askOnboardingQues") && localStorage.getItem("askOnboardingQues") == 'true') {
        this.setState({
          showOnboardingQues: true
        });
      }
    }

    if (!IsEmpty(this.props.token)) {
      this.setParentWrapperClass(this.props, true);
    } else {
      this.setParentWrapperClass(this.props, false);
    }
  };

  removeActive = event => {
    if (
      !IsEmpty(document.getElementsByClassName("liClass")[0]) &&
      !document.getElementsByClassName("liClass")[0].contains(event.target)
    ) {
      document.getElementsByClassName("liClass")[0].classList.remove("active");
    }
  };

  fetchOnboardingQuestion = (language) => {
    if (localStorage.getItem("askOnboardingQues") && localStorage.getItem("askOnboardingQues") == 'true') {
      const config = {
        headers: {
          "cache-control": "no-cache",
          "content-type": "application/json",
          "token": localStorage.getItem("token")
        }
      };
      const reqBody = {}

      axiosUserManagement
        .post("/subscriber/user/profile/question/fetch", reqBody, { ...config })
        .then(res => {
          var apiResp = res.data;
          if (apiResp.length > 0) {
            apiResp = getContentWithLanguage(apiResp, language);
            this.setState({ onboardingQues: apiResp });
          }
        })
        .catch(err => {
          handleActionError("Error while attempting to fetch subscriber onboarding questions:", err);
          localStorage.removeItem("askOnboardingQues");
          console.error('Unable to fetch questions, please check later');
        });
    }
  };

  saveQuestionResponses = (questionResponses = []) => {
    if (questionResponses.length > 0) {
      let config = {
        headers: {
          "cache-control": "no-cache",
          "content-type": "application/json"
        }
      };
      let reqBody = {
        "questionResponseList": questionResponses,
        "jwt": localStorage.getItem("token")
      }
      axiosUserManagement
        .post("/subscriber/question/responses/save", reqBody, { ...config })
        .then(res => {
          if (res.status == 200) { // success response
            console.log('answer saved for this user');
          }
        })
        .catch(err => {
          handleActionError("An error occurred while attempting to save subscriber onboarding question responses:", err);
        });
    } else {
      // this.registerUserForEvent();
    }
  };

  componentDidMount = () => {
    analytics("web_app_loaded");
    setUserProperties({
      login_status: "false"
    });

    if (localStorage.getItem("firebaseSignupEvent")) {
      signUpAnalytics();
    }

    if (isMobile) {
      this.showScheduleToggler();
    }

    document.addEventListener("click", this.removeActive);

    if (localStorage.getItem("token") && localStorage.getItem("askOnboardingQues") && localStorage.getItem("askOnboardingQues") == 'true') {
      this.setState({
        showOnboardingQues: true
      });
    }

    if (this.props.location.search != "") {
      let searchParams = new URLSearchParams(
        this.props.location.search.split("?")[1]
      );
      // --> Signup analytics code
      if (searchParams.has("sucessToken") && searchParams.get("preferencesSet") == "false") {
        let provider = searchParams.has("provider") ? searchParams.get("provider") : '';
        if (provider) {
          if (provider == "GOOGLE") {
            localStorage.setItem("firebaseSignupEvent", "registration_complete_google");
          } else if (provider == "LINKEDIN") {
            localStorage.setItem("firebaseSignupEvent", "registration_complete_linkedin");
          } else if (provider == "APPLE") {
            localStorage.setItem("firebaseSignupEvent", "registration_complete_apple");
          }
        }
      }
      // Signup analytics code --<
      // --> Sparkloop Referral code
      if (searchParams.get("preferencesSet")) {
        localStorage.setItem("isOldUser", searchParams.get("preferencesSet"));
        localStorage.setItem("askOnboardingQues", searchParams.get("preferencesSet") == 'false' ? true : false);
      }

      // Sparkloop Referral code --<
      this.switchPopup(searchParams);
    }

    if (!IsEmpty(localStorage.getItem("token"))) {
      this.props.setToken(localStorage.getItem("token"));
      this.getUserInfo(localStorage.getItem("token"));
      this.updateLastSeenTimestamp(localStorage.getItem("token"));
      this.setParentWrapperClass(this.props, true);
      this.fetchOnboardingQuestion(this.props.currentLanguage);
    } else {
      this.props.setToken(null);
      this.setParentWrapperClass(this.props, false);
    }

    axiosContentDetail
      .get("/api/v1/rootNodeAndFirstChild")
      .then(res => {
        const filteredByLanguage = getContentWithLanguage(res.data.data, this.props.currentLanguage);
        this.setState({
          nodeTier: filteredByLanguage
        });
      })
      .catch(err => {
        handleActionError("An error occurred while attempting to retrieve root node and first child:", err);
      });

    axiosContentDetail
      .get("/api/v1/event/series?statusType=ACTIVE")
      .then(res => {
        const filteredByLanguage = getContentWithLanguage(res.data.data, this.props.currentLanguage);
        this.setState({
          nodeSeries: filteredByLanguage
        });
      })
      .catch(err => {
        handleActionError("An error occurred while attempting to retrieve active series data:", err);
      });
  };

  componentWillUnmount = () => {
    document.removeEventListener("click", this.removeActive);
  }

  updateLastSeenTimestamp = (jwtToken) => {
    let config = {
      headers: {
        "cache-control": "no-cache",
        "content-type": "application/json"
      }
    };
    let reqBody = {
      "token": jwtToken
    }
    axiosUserManagement
      .post("/update-last-seen-timestamp", reqBody, { ...config })
      .then(res => {
      })
      .catch(err => {
        handleActionError("An error occurred while attempting to update the subscriber's last-seen timestamp:", err);
      });
  };

  getUserInfo = token => {
    if (!IsEmpty(token)) {
      this.props.setUser(token);
    }
  };

  saveToken = (token, provider) => {
    if (provider) {
      localStorage.setItem("token", token);
    }
    this.props.setToken(token, provider);
  };

  switchPopup = searchParams => {
    let refrenceThis = this;
    switch (true) {
      case searchParams.has("error"):
        setTimeout(function () {
          refrenceThis.resetlinkedInErrorMessage();
        }, setTimeoutMessage);
        this.setState({
          linkedInErrorMessage: searchParams.get("error")
        });
        this.props.history.push("/");
        break;
      case searchParams.has("delete"):
        setTimeout(function () {
          refrenceThis.resetlinkedInErrorMessage();
        }, setTimeoutMessage);
        this.setState({
          linkedInErrorMessage: searchParams.get("delete")
        });
        this.props.history.push("/");
        break;
      case searchParams.has("sucessToken") &&
        searchParams.get("preferencesSet") == "false":
        this.props.setSignupFlow();
        localStorage.setItem("token", searchParams.get("sucessToken"));
        this.getUserInfo(searchParams.get("sucessToken"));
        this.saveToken(searchParams.get("sucessToken"), searchParams.get("provider"));
        this.props.history.push("/signup/complete");
        break;
      case searchParams.has("sucessToken") &&
        searchParams.get("preferencesSet") == "true":
        this.saveToken(searchParams.get("sucessToken"), searchParams.get("provider"));
        localStorage.setItem("token", searchParams.get("sucessToken"));
        this.getUserInfo(searchParams.get("sucessToken"));
        this.props.history.push("/");
        break;
      default:
        break;
    }
  };

  openModalPopup = () => {
    this.setState({
      openPopup: true
    });
  };

  resetPopupProps = () => {
    this.setState({
      openPopup: false
    });
  };

  openSignupModalPopupFromTop = (formName) => {
    analytics("sign_up_at_top");
    this.openSigninModalPopup(formName);
  };

  openSigninModalPopup = (formName = "signin") => {
    this.props.setSignupModalStatus(true, formName);
  };


  resetlinkedInErrorMessage = () => {
    this.setState({
      linkedInErrorMessage: null
    });
  };

  isThisNotificationForMeHandler = (response, error) => {
    if (response && response.result == true) {
      this.appendNewWSNotification(response.notification);
    }
  }

  appendNewWSNotification = (msg) => {
    let reducedNotifications = this.state.notification;
    if (reducedNotifications.length >= MAX_NOTIFICATIONS_ALLOWED) { // remove oldest if count is more than or equals to MAX_NOTIFICATIONS_ALLOWED
      reducedNotifications.splice(-1);
    }
    this.setState({
      notification: [msg, ...reducedNotifications]
    });
  }

  updateNotificationReadStatus = (notificationIds = [], isDailyWrap = false) => {
    if (isDailyWrap) {
      let updated_notifications = [];
      this.setState({
        notification: updated_notifications
      });
    } else {
      let updated_notifications = [];
      Object.values(this.state.notification).map(values => {
        if (notificationIds.indexOf(values.id) > -1) {
          values.isRead = true;
        }
        updated_notifications.push(values);
      });
      this.setState({
        notification: updated_notifications
      });
    }
  };

  handleGlobalClick = (e) => {
    if (!e.target.classList.contains('keepNotificationEnabled') && this.state.showNotification) {
      this.toggleNotification();
    }
  }

  toggleNotification = (newState = false) => {
    this.setState({
      showNotification: newState
    });
  };

  quesModalToggle = () => {
    this.setState({ showOnboardingQues: !this.state.showOnboardingQues });
  }

  render = () => {
    const paths = [
      "all",
      "aboutus",
      "search",
      "profile",
      "topic",
      "notfound500"
    ];
    const pathsDark = [
      "signin",
      "signup",
      "resetpassword",
      "accountVerification",
      "forgotPassword",
      "media",
      "delete"
    ];
    const pathFound = paths.find(
      e => this.props.location.pathname.indexOf(e) > 0
    );
    const pathFoundDark = pathsDark.find(
      e => this.props.location.pathname.indexOf(e) > 0
    );

    return (

      <React.Fragment>
        <div
          className={
            pathFound
              ? "content-wrapper"
              : pathFoundDark || this.props.location.pathname == "/"
                ? "content-wrapper drakColor"
                : "content-wrapper"
          }
          onClick={((e) => this.handleGlobalClick(e))}
        >
          <div
            className={
              this.state.linkedInErrorMessage
                ? "profileUpdate errorShow display show"
                : "profileUpdate"
            }
          >
            {this.state.linkedInErrorMessage}
            <span
              className="clickableElement"
              onClick={() => this.resetlinkedInErrorMessage()}
            >
              Close
            </span>
          </div>
          {IsEmpty(this.props.token) &&
            !(
              this.props.location.pathname.indexOf("signup") > 0 ||
              this.props.location.pathname.indexOf("signin") > 0 ||
              this.props.location.pathname.indexOf("events/") > 0 ||
              this.props.location.pathname.indexOf("search") > 0
            ) ? (
            <div className="signUpDisclamer">
              Stop playing catch-up. Start watching ausbiz.
              <span
                className="overlay-signin"
                onClick={() => this.openSignupModalPopupFromTop("signup")}
              >
                Sign up for free
              </span>
            </div>
          ) : null}
          {this.props.location.pathname != "/search" && this.props.location.pathname.indexOf("events/") < 0 && (
            <Header
              isloggedin={!IsEmpty(this.props.token)}
              isSignupView={
                this.props.location.pathname.indexOf("signup") > 0 ||
                this.props.location.pathname.indexOf("signin") > 0
              }
              popup={this.openModalPopup}
              openSigninpopup={this.openSigninModalPopup}
              nodeTier={this.state.nodeTier}
              nodeSeries={this.state.nodeSeries}
              notification={this.state.notification}
              updateNotificationReadStatus={this.updateNotificationReadStatus}
              showNotification={this.state.showNotification}
              toggleNotification={this.toggleNotification}
            />
          )}
          <main
            className={this.mainWrapperClass}
          >
            {renderRoutes(this.props.route.routes, {
              showSchedule: this.state.showSchedule,
              showScheduleToggler: this.showScheduleToggler
            })}
            <Modal
              openPopup={this.state.openPopup}
              resetPopupProps={this.resetPopupProps}
              modalID="menu"
            >
              <Menu
                nodeTier={this.state.nodeTier}
                nodeSeries={this.state.nodeSeries}
              />
            </Modal>
            {this.props.signUpModalStatus &&
              <SigninPopup requestedForm={this.state.userAuthenticationForm} />
            }
            {this.state.showOnboardingQues &&
              <QuestionPopup
                allQues={this.state.onboardingQues}
                showQuestionPopup={this.state.showOnboardingQues}
                questionPopupClosedHandler={this.quesModalToggle.bind(this)}
                questionSuccessHandler={this.saveQuestionResponses}
                wait={4000}
                currentLanguage={this.props.currentLanguage}
              />
            }
          </main>
        </div>
        <Footer isSignin={this.props.location.pathname.indexOf("signin") > 0} />
        <LoaderComponent isLoading={this.props.loader} />
      </React.Fragment>
    );
  };
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    loader: state.loader.loader,
    provider: state.auth.provider,
    signUpModalStatus: state.signup.signUpModalStatus,
    currentLanguage: state.language.currentLanguage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setToken: (token, provider) => dispatch(setToken(token, provider)),
    setUser: token => dispatch(setUser(token)),
    onLogout: () => dispatch(logout()),
    setSignupFlow: () => dispatch(setSignupFlow()),
    setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm))
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(App)
};
